<template>
  <div class="common-contacts">
    <el-popover ref="popover" trigger="click" width="500" @show="handerShowPop">
      <div v-if="!this.isEmpty" v-loading="loading">
        <div class="contactPersion">
          <div class="title">
            <i class="iconfont iconidcard" />
            业务联系人
          </div>
          <div class="rj-flex">
            <div style="width:200px;">
              姓名：{{ info.businessName }}
            </div>
            <div class="rj-flex__item">
              座机：{{ info.businessTel }}
            </div>
          </div>
          <div class="rj-flex">
            <div style="width:200px;">
              手机：{{ info.businessMobile }}
            </div>
            <div class="rj-flex__item">
              邮箱：{{ info.businessEmail }}
            </div>
          </div>
        </div>
        <div class="contactPersion">
          <div class="title">
            <i class="iconfont iconidcard" />
            商务联系人
          </div>
          <div class="rj-flex">
            <div style="width:200px;">
              姓名：{{ info.commerceName }}
            </div>
            <div class="rj-flex__item">
              座机：{{ info.commerceTel }}
            </div>
          </div>
          <div class="rj-flex">
            <div style="width:200px;">
              手机：{{ info.commerceMoblie }}
            </div>
            <div class="rj-flex__item">
              邮箱：{{ info.commerceEmail }}
            </div>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center;font-size: 16px;padding: 20px">
        暂无数据
      </div>
      <i slot="reference" class="iconfont iconphone1" />
    </el-popover>
  </div>
</template>
<script type="es6">
import { getContactInfo } from '../../API/index';
export default {
  data () {
    return {
      loading: false,
      info: {}
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {},
  computed: {
    isEmpty () {
      return !this.info.businessName && !this.loading;
    }
  },
  methods: {
    handerShowPop () {
      // 弹出层出现时回调 此时请求数据
      this.initData();
    },
    initData () {
      this.loading = true;
      getContactInfo(this.id).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.info = json.data;
          this.$nextTick(() => {
            this.$refs.popover.updatePopper();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.popover.updatePopper();
          });
        }
      }).catch(() => {
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.popover.updatePopper();
        });
      });
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
  @import "../../style/var";
  .common-contacts{
    width: 40px;
    text-align: center;
    color: $--color-primary;
    cursor: pointer;
    display: inline-block;
  }
  .contactPersion{
    line-height: 30px;
    font-size: 13px;
    .title{
      font-size: 15px;
      color: $--color-text-primary;
      i {
        color: $--color-primary;
        margin-right: 10px;
      }
    }
  }
</style>
